import './programs.scss';
//library
import { useQuery } from '@apollo/client';
import format from 'date-fns/format';
import es from 'date-fns/locale/es';
import { useLocation, useNavigate } from 'react-router-dom';
//shared
import { PROGRAMS } from '../shared/graphql/programs';
import { TITLE_PROGRAMS } from './constants/title';
import { SkeletonPrograms } from '../shared/components/skeleton-programs/skeleton-programs';
import { DataNotFound } from '../shared/components/data-not-found/data-not-found';
import { DATA_NOT_FOUND } from './constants/DataNotFound';
//material
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { useEffect } from 'react';
import { sendPageView } from '../shared/services/analytics';

const GetPrograms = () => {

    const location = useLocation();
    useEffect(() => {
        sendPageView(location.pathname + location.search, "Programas");
    }, [location]);

    let currentPrograms: any[] = [];
    let futurePrograms: any[] = [];
    let imageProgram: string = 'https://fitpal-public.s3.amazonaws.com/Tipos_entrenamiento/new_images/1643045161186.png';

    const { data, loading, error, refetch } = useQuery(PROGRAMS);
    refetch();

    let currentDate: any = new Date();
    currentDate = currentDate.toISOString().split('T')[0];

    if (loading) return <SkeletonPrograms></SkeletonPrograms>;
    if (error) console.log(`Submission error! ${error.message}`);

    if (data && !data.teacherPrograms) return <DataNotFound data={DATA_NOT_FOUND} />;
    if (data && data.teacherPrograms) {
        data.teacherPrograms.forEach((program: any) => {
            if (program.start_date.split(' ')[0] === currentDate) {
                currentPrograms.push({
                    id: program.program_id,
                    name: program.name,
                    start: program.start_date,
                    end: program.end_date,
                    img: program.new_image ? program.new_image : imageProgram,
                });
            }
            
            if (program.start_date.split(' ')[0] <= currentDate && program.end_date.split(' ')[0] >= currentDate) {
                futurePrograms.push({
                    id: program.program_id,
                    name: program.name,
                    start: program.start_date,
                    end: program.end_date,
                    img: program.new_image ? program.new_image : imageProgram,
                });
            }
        })
    };


    return (
        <div className='mt-5'>

            {!currentPrograms.length && !futurePrograms.length && (
                <DataNotFound data={DATA_NOT_FOUND} />
            )}

            {currentPrograms.length > 0 && (
                <div>
                    <h2 className='title-tag-program mb-1'>Programa actual</h2>
                    {currentPrograms.map((program: any) => (
                        <Program program={program}></Program>

                    ))}
                </div>
            )}

            {futurePrograms.length > 0 && (
                <div>
                    <h2 className='title-tag-program mb-1 mt-4'>Siguientes programas</h2>
                    {futurePrograms.map((program: any) => (
                        <Program program={program}></Program>
                    ))}
                </div>
            )}

        </div>
    );
}

const Program = ({ program }: { program: any }) => {

    const navigate = useNavigate();

    const buttonClick = (programId: number) => {
        navigate(`/program/${programId}`);
    }

    return (
        <Grid container className='card-program'>
            <Grid item xs={3}>
                <div className='contain-img'>
                    <img src={program.img} alt='fitpal' className='img-card' />
                </div>
            </Grid>
            <Grid item xs={9} className='content'>
                <h3>{program.name}</h3>
                <h4>
                    {format(new Date(program.start), "dd MMMM yyyy", { locale: es })} - {format(new Date(program.end), "dd MMMM yyyy", { locale: es })}
                </h4>
                <Button className='button-card' onClick={() => buttonClick(program.id)}>
                    Ver clases
                </Button>
            </Grid>
        </Grid >
    );
}

export default function Programs() {

    const navigate = useNavigate();

    const buttonClickProgramHistory = () => {
        navigate(`/program-history`);
    }

    return (
        <div className='section-main-programs'>
            <Grid container justifyContent={'center'}>
                <Grid item xs={5} className='title-programs'>
                    <Grid container justifyContent={'center'} alignItems={'center'} display={'flex'} direction={'column'} >
                        <h1>{TITLE_PROGRAMS.title}</h1>
                        <p className='mb-1'>{TITLE_PROGRAMS.description}</p>
                        <Button className='btn-fitpal-secondary btn-history' onClick={() => buttonClickProgramHistory()}>
                            Historial
                        </Button>
                    </Grid>
                </Grid>
                <Grid item xs={7} className='section-programs'>
                    <GetPrograms />
                </Grid>
            </Grid>
        </div>
    );
};